<template>
  <div class="landing-page">
    <div class="landing-title">
      {{ $t('text.welcome_to_the_administration_section') }}
    </div>
    <el-row
      :gutter="30"
      :type="$root.screenWidth > 991 ? 'flex' : ''"
      id="quick-actions"
    >
      <el-col :xs="24" :md="12" class="profile-column">
        <div class="section-card hp-100">
          <div class="section-card-title profile-card-title">
            <span>{{ $t('text.profile') }}</span>
          </div>
          <div v-loading="loading">
            <div class="profile-item">
              <div class="left-side">
                <img src="@/assets/image/profile/home.png" />
              </div>
              <div class="right-side">
                <div class="profile-title">
                  <span>{{ $t('text.name') }}</span>
                </div>
                <div class="profile-desc">
                  {{ profile.OrganisationName || '--' }}
                </div>
              </div>
            </div>
            <div class="profile-item">
              <div class="left-side">
                <img src="@/assets/image/profile/residents.png" />
              </div>
              <div class="right-side">
                <div class="profile-title">
                  <span>{{ $t('text.patients') }}</span>
                </div>
                <div class="profile-desc">
                  {{
                    profile.Residents &&
                    (profile.Residents.Active || profile.Residents.Active === 0)
                      ? profile.Residents.Active
                      : '--'
                  }}
                  ({{ $t('text.active') }}),
                  {{
                    profile.Residents &&
                    (profile.Residents.Archived ||
                      profile.Residents.Archived === 0)
                      ? profile.Residents.Archived
                      : '--'
                  }}
                  ({{ $t('text.not_monitored') }})
                </div>
              </div>
            </div>
            <div class="profile-item">
              <div class="left-side">
                <img src="@/assets/image/profile/pods.png" />
              </div>
              <div class="right-side">
                <div class="profile-title">
                  <span>{{ $t('text.pods') }}</span>
                </div>
                <div class="profile-desc">
                  {{ profile.Pods === 0 || profile.Pods ? profile.Pods : '--' }}
                </div>
              </div>
            </div>
            <div class="profile-item">
              <div class="left-side">
                <img src="@/assets/image/profile/nodes.png" />
              </div>
              <div class="right-side">
                <div class="profile-title">
                  <span>{{ $t('text.nodes') }}</span>
                </div>
                <div class="profile-desc">
                  {{
                    profile.Nodes === 0 || profile.Nodes ? profile.Nodes : '--'
                  }}
                </div>
              </div>
            </div>
            <div class="profile-item">
              <div class="left-side">
                <img src="@/assets/image/profile/products.png" />
              </div>
              <div class="right-side">
                <div class="profile-title">
                  <span>{{ $t('text.products') }}</span>
                </div>
                <div class="profile-desc">
                  <div v-if="profile.Products">
                    <div
                      v-for="item in profile.Products"
                      :key="item.ManufacturerName"
                    >
                      <span>{{ item.ManufacturerName }}</span> -
                      <span
                        v-for="(product, index) in item.Products"
                        :key="product"
                      >
                        {{ product }}
                        <span v-if="index !== item.Products.length - 1">,</span>
                      </span>
                    </div>
                  </div>
                  <div v-else>--</div>
                </div>
              </div>
            </div>
            <div class="profile-item">
              <div class="left-side">
                <img src="@/assets/image/profile/rounds.png" />
              </div>
              <div class="right-side">
                <div class="profile-title">
                  <span>{{ $t('text.rounds') }}</span>
                </div>
                <div class="profile-desc">
                  <div>
                    {{ $t('text.day').toLowerCase() | firstLetterCapitalize }}:
                    {{
                      profile.Rounds && profile.Rounds.Day
                        ? profile.Rounds.Day
                        : '--'
                    }}
                  </div>
                  <div>
                    {{
                      $t('text.night').toLowerCase() | firstLetterCapitalize
                    }}:
                    {{
                      profile.Rounds && profile.Rounds.Night
                        ? profile.Rounds.Night
                        : '--'
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col
        :xs="24"
        :md="12"
        v-if="
          p('Manage Module.Patients.Patients Module.Add') ||
            p('Manage Module.Patients.Patients Module.Edit') ||
            p('Manage Module.Users.Invite User.Save') ||
            p('Manage Module.Patients.Patients Module.Delete')
        "
      >
        <div class="section-card hp-100">
          <div class="section-card-title">
            <img
              class="title-icon"
              src="@/assets/image/quick-action-icon.png"
            />
            <span>{{ $t('text.quick_actions') }}</span>
          </div>
          <div
            v-for="action in quickActions"
            :key="action.title"
            class="quick-operate-item"
            @click="action.onClickAction(action.title, action.actionType)"
            v-show="p(action.permission)"
          >
            <div class="left-icon-wrapper v-h-center">
              <img
                :src="
                  require('@/assets/image/quick-operation-icon/' + action.icon)
                "
                :style="{ width: action.iconWidth + 'px' }"
              />
            </div>
            <div class="right-content">
              <div class="quick-operate-title">{{ action.title }}</div>
              <div class="quick-operate-desc">{{ action.desc }}</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <EditPatient ref="editPatient" />
    <UpdatePatientDeviceAndProucts ref="updatePatientDeviceAndProucts" />
    <InviteUserDialog ref="inviteUser" />
    <RemoveOrArchivePatient ref="removeOrArchivePatient" />
  </div>
</template>

<script>
import EditPatient from '@/components/manage/patients/EditPatient.vue'
import UpdatePatientDeviceAndProucts from '@/components/patients/quickActions/UpdatePatientDeviceAndProucts.vue'
import InviteUserDialog from '@/components/manage/user/InviteUserDialog.vue'
import RemoveOrArchivePatient from '@/components/manage/patients/RemoveOrArchivePatient.vue'
import { patientQuickActions } from '@/const'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import moment from 'moment'
export default {
  data() {
    return {
      quickActions: [
        {
          title: this.$t('text.add_patient'),
          desc: this.$t('text.add_patient_quick_action_desc') + '.',
          onClickAction: this.addPatient,
          icon: 'add-patient.png',
          iconWidth: 36,
          actionType: patientQuickActions.addPatient,
          permission: 'Manage Module.Patients.Patients Module.Add'
        },
        {
          title: this.$t('text.invite_user'),
          desc: this.$t('text.invite_user_quick_action_desc') + '.',
          onClickAction: this.inviteUser,
          icon: 'add-user.png',
          iconWidth: 39,
          actionType: null,
          permission: 'Manage Module.Users.Invite User.Save'
        },
        {
          title: this.$t('text.remove_or_archive_patient'),
          desc:
            this.$t('text.remove_or_archive_patient_quick_action_desc') + '.',
          onClickAction: this.removeOrArchivePatient,
          icon: 'remove-or-archive-patient.png',
          iconWidth: 34,
          actionType: null,
          permission: 'Manage Module.Patients.Patients Module.Delete'
        },
        {
          title: this.$t('text.reassign_pod_to_patient'),
          desc: this.$t('text.reassign_pod_quick_action_desc') + '.',
          onClickAction: this.updatePatientDeviceAndProucts,
          icon: 'reassign-pod.png',
          iconWidth: 36,
          actionType: patientQuickActions.assignPod,
          permission: 'Manage Module.Patients.Patients Module.Edit'
        },
        {
          title: this.$t('text.monitor_patient_with_a_node'),
          desc:
            this.$t('text.monitor_patient_with_a_node_quick_action_desc') + '.',
          onClickAction: this.updatePatientDeviceAndProucts,
          icon: 'assign-node.png',
          iconWidth: 36,
          actionType: patientQuickActions.assignNode,
          permission: 'Manage Module.Patients.Patients Module.Edit'
        }
      ],
      loading: false,
      profile: {}
    }
  },
  components: {
    EditPatient,
    UpdatePatientDeviceAndProucts,
    InviteUserDialog,
    RemoveOrArchivePatient
  },
  mounted() {
    this.getOrganisationProfile()
  },
  methods: {
    getOrganisationProfile() {
      this.loading = true
      ApiService.GetOrganisationProfile(
        this.$store.getters[`user/selecteOrganisationId`]
      ).then(response => {
        this.loading = false
        if (response.data.success) {
          this.profile = response.data.data
          this.profile.Rounds = {
            Day:
              this.profile.Rounds.Day !== '-'
                ? moment(
                    moment().format('YYYY-MM-DD ') + this.profile.Rounds.Day
                  ).format('h A')
                : '-',
            Night:
              this.profile.Rounds.Night !== '-'
                ? moment(
                    moment().format('YYYY-MM-DD ') + this.profile.Rounds.Night
                  ).format('h A')
                : '-'
          }
        } else {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    addPatient() {
      this.$refs.editPatient.openDialog()
    },
    updatePatientDeviceAndProucts(title, actionType) {
      this.$forceUpdate()
      this.$refs.updatePatientDeviceAndProucts.openDialog(title, actionType)
    },
    inviteUser() {
      this.$refs.inviteUser.openDialog()
    },
    removeOrArchivePatient() {
      this.$refs.removeOrArchivePatient.openDialog()
    }
  }
}
</script>
